/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureResponse
 */
export interface FeatureResponse {
    /**
     * 
     * @type {string}
     * @memberof FeatureResponse
     */
    featureName: FeatureResponseFeatureNameEnum;
    /**
     * 
     * @type {string}
     * @memberof FeatureResponse
     */
    targetId: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureResponse
     */
    targetType: string;
    /**
     * 
     * @type {Date}
     * @memberof FeatureResponse
     */
    validUntil: Date | null;
}


/**
 * @export
 */
export const FeatureResponseFeatureNameEnum = {
    QwenModel: 'QwenModel',
    TokenLimit: 'TokenLimit'
} as const;
export type FeatureResponseFeatureNameEnum = typeof FeatureResponseFeatureNameEnum[keyof typeof FeatureResponseFeatureNameEnum];


/**
 * Check if a given object implements the FeatureResponse interface.
 */
export function instanceOfFeatureResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "featureName" in value;
    isInstance = isInstance && "targetId" in value;
    isInstance = isInstance && "targetType" in value;
    isInstance = isInstance && "validUntil" in value;

    return isInstance;
}

export function FeatureResponseFromJSON(json: any): FeatureResponse {
    return FeatureResponseFromJSONTyped(json, false);
}

export function FeatureResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'featureName': json['featureName'],
        'targetId': json['targetId'],
        'targetType': json['targetType'],
        'validUntil': (json['validUntil'] === null ? null : new Date(json['validUntil'])),
    };
}

export function FeatureResponseToJSON(value?: FeatureResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'featureName': value.featureName,
        'targetId': value.targetId,
        'targetType': value.targetType,
        'validUntil': (value.validUntil === null ? null : value.validUntil.toISOString()),
    };
}

